/*
 *
 * App actions
 *
 */

import {
  CHANGE_CURRENT_PROJECT_START,
  CHANGE_CURRENT_PROJECT_SUCCESS,
  GET_TEAMS_ONLY_TOKEN,
} from './constants';
import { defineAction } from 'utils/action-helper';

export const getTeamsOnlyToken = {
  start: ({ metadata }) => defineAction({ type: GET_TEAMS_ONLY_TOKEN.START, metadata }),
  success: ({ data }) =>
    defineAction({
      type: GET_TEAMS_ONLY_TOKEN.SUCCESS,
      payload: { data },
    }),
  error: error =>
    defineAction({
      type: GET_TEAMS_ONLY_TOKEN.ERROR,
      payload: { error },
    }),
};

export const changeCurrentProject = ({ payload, metadata }) => {
  return {
    type: CHANGE_CURRENT_PROJECT_START,
    payload,
    metadata,
  };
};

export const changeCurrentProjectSuccess = data => {
  return {
    type: CHANGE_CURRENT_PROJECT_SUCCESS,
    payload: {
      data,
    },
  };
};
